export const initialState = {
  fetched: false,
  data: null,
  _default_spec: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'PEOPLE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          fetched: true,
          data: action.payload.data,
          _default_spec: action.payload._default_spec,
        });
      } else {
        return Object.assign({}, state, { fetched: true, data: null, _default_spec: null });
      }
    default:
      return state;
  }
}
